import MonitorManager from './Monitor/MonitorManager';

const AppMonitor = {
	init() {
		MonitorManager.initialize();
	},
};

export default AppMonitor;
